import Vue from 'vue';
import { format as dateFormat, format, isValid as isValidDate } from 'date-fns';

Vue.filter('timestampToString', function(timestamp) {
  if (!timestamp) return '';
  // Converts a date value to string using a predefined format
  var month_names = new Array("Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec");

  var date = new Date(parseInt(timestamp, 10) * 1000);
  var hours = date.getHours();
  var suffix = (hours >= 12) ? "pm" : "am";

  if(hours === 0) {
    hours = 12;
  } else if(hours > 12) {
    hours -= 12;
  }

  // 0-pad the minutes. Is there really not a javascript function for this
  var minutes = '' + date.getMinutes();

  while(minutes.length < 2)
  minutes = '0' + minutes;

  return(month_names[date.getMonth()] + " " + date.getDate() + " " + date.getFullYear() + " - " + hours + ":" + minutes + suffix);

  // return(date.getDate() + " " + month_names[date.getMonth()] + " " + hours + ":" + minutes + suffix);
});

Vue.filter('timestamp', function(str) {
  if (!str) return '';

  var date = new Date(str);
  return ('0' + (date.getMonth() + 1)).slice(-2) + '/'  + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear();
});

Vue.filter('toMinutesAndSeconds', function(milliseconds) {
  var minutes = Math.floor(milliseconds / 60000),
      seconds = ((milliseconds % 60000) / 1000).toFixed(0);

  return minutes + ":" + (seconds < 10 ? '0' : '') + seconds;
});

Vue.filter('formatTimestamp', function(str) {
  var d = new Date(+str),
      curr_date = d.getDate(),
      curr_month = d.getMonth() + 1,
      curr_year = d.getFullYear();

  return curr_month + "/" + curr_date + "/" + curr_year;
});

Vue.filter('monthDay', (date) => format(new Date(date), 'MM/dd'));

Vue.filter('eventDisplayName', (game) => {
  const scheduledFor = game?.scheduledFor;
  const participantType = game?.participantType;
  const parsedScheduledFor = scheduledFor ? new Date(scheduledFor) : null;
  const eventDate = parsedScheduledFor && isValidDate(parsedScheduledFor)
    ? dateFormat(parsedScheduledFor, 'MM/dd/yyyy')
    : '';

  const awayTeamAlias = game?.awayTeam?.teamAlias;
  const homeTeamAlias = game?.homeTeam?.teamAlias;
  if (participantType === 'team_v_team' || (awayTeamAlias && homeTeamAlias)) {
    return eventDate
      ? `${eventDate}: ${awayTeamAlias || 'TBD'} @ ${homeTeamAlias || 'TBD'}`
      : `${awayTeamAlias || 'TBD'} @ ${homeTeamAlias || 'TBD'}`;
  }

  const eventTitle = game?.eventTitle || 'TBD';
  return eventDate ? `${eventDate} @ ${eventTitle}` : `@ ${eventTitle}`;
});

Vue.filter('playerDisplayName', (player) => {
  let firstName = player?.firstName || '';
  let lastName = player?.lastName || '';
  if (!lastName.length && firstName.length) {
    lastName = firstName;
    firstName = '';
  }
  if (!lastName.length) {
    lastName = 'Unknown Player';
  }

  return (!firstName.length)
    ? lastName
    : `${lastName}, ${firstName}`;
});
